import { render, staticRenderFns } from "./factureViewFraisComponent.vue?vue&type=template&id=1f0a5d74&"
import script from "./factureViewFraisComponent.vue?vue&type=script&lang=js&"
export * from "./factureViewFraisComponent.vue?vue&type=script&lang=js&"
import style0 from "./factureViewFraisComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports